import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { ValidationError } from '../../../../domain/error.model';
import { OfferRequest } from '../../../../domain/offer.domain';
import { Party } from '../../../../domain/party.domain';
import { ScheduleFlag } from '../../../../domain/schedule.model';
import { EntityRole, SystemUser } from '../../../../domain/user.model';
import { ErrorAwareComponent, LsnErrorStateMatcher } from '../../../shared/middleware/error-state-matcher';
import { ErrorsState } from '../../store/errors.state';
import { OfferAction } from '../../store/offer.action';
import { ScheduleState } from '../../store/schedule.state';
import { UserState } from '../../store/user.state';

@Component({
    selector: 'app-new-offer',
    templateUrl: './new-offer.component.html',
    styleUrls: ['./new-offer.component.scss']
})

export class NewOfferComponent implements OnInit, OnDestroy, ErrorAwareComponent {

    subscriptions: Subscription[] = [];
    request = new OfferRequest();

    errors: ValidationError[] = [];
    user: SystemUser;
    flag: ScheduleFlag;

    matchers = {
        policyholderIsInsuredPerson: new LsnErrorStateMatcher(this, 'policyholderIsInsuredPerson'),
        insuredPersonList: new LsnErrorStateMatcher(this, 'insuredPersonList'),
    };

    get readonly() {
        return this.flag.active === false
            || [EntityRole.WORKER, EntityRole.AGENT, EntityRole.DIRECT_SALES].indexOf(this.user.entityRole) === -1;
    }

    constructor(private store: Store) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.store.select(ErrorsState.getMainErrors).subscribe(errors => this.errors = errors),
            this.store.select(UserState.getUser).subscribe(user => this.user = user),
            this.store.select(ScheduleState.getFlag).subscribe(flag => this.flag = flag),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    addInsured() {
        this.request.insuredPersonList.push(new Party());
    }

    save() {
        this.store.dispatch(new OfferAction.CreateCalculation(this.request));
    }


    remove(index: number) {
        this.request.insuredPersonList.splice(index, 1);
    }
}
